export default function() {
    const logosSliders = document.querySelectorAll('.logo-slider .logo-wrapper');
    if (logosSliders && logosSliders.length > 0) {
        logosSliders.forEach(slider => {
            let logosList = slider.querySelector('.logos-list');
            if (logosList) {
                let logosListDuplicate = logosList.cloneNode(true);
                slider.appendChild(logosListDuplicate);
            }
        });
    }
}